import React from 'react';
import CheckCircleIcon from '@atlaskit/icon/core/migration/success--check-circle';
import { token } from '@atlaskit/tokens';
import type { ARTICLE_TYPE } from '@atlaskit/help';
import { FormattedMessage } from '@atlassian/jira-intl';
import { FireUiAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { Flag } from '../../../common/ui/flag/index.tsx';
import { messages } from './messages.tsx';

interface Props {
	onDismiss: () => void;
	openInProductHelp: (id: string, type?: keyof typeof ARTICLE_TYPE) => void;
}

export const FinishFlag = ({ onDismiss, openInProductHelp }: Props) => (
	<>
		<FireUiAnalytics
			actionSubject="flag"
			action="viewed"
			actionSubjectId="finishedAdvancedRoadmapsOnboarding"
		/>
		<Flag
			isAutoDismissed
			icon={<CheckCircleIcon spacing="spacious" label="" color={token('color.icon.success')} />}
			onDismissed={onDismiss}
			title={<FormattedMessage {...messages.flagTitle} />}
			description={<FormattedMessage {...messages.plansFlagContent} />}
			actions={[
				{
					content: <FormattedMessage {...messages.flagClose} />,
					onClick: onDismiss,
				},
				{
					content: <FormattedMessage {...messages.flagViewDocumentation} />,
					onClick: () => openInProductHelp(''),
				},
			]}
		/>
	</>
);
